<div [ngClass]="{'fullscreen': esPantallaCompleta}">
  <div class="container-fluid">
    <div class="row align-items-center">
      <div class="col-3 text-center">
        <a href="">
          <img routerLink="{{urlBase()}}" src="assets/images/ACE_Acceso-Express.png" class="img-fluid" style="max-height: 70px;"/>
        </a>
      </div>

      <div class="col-6 text-center">
        <h2 class="text-primary fw-semibold mb-0 lh-1">ASESOR CONTABLE EXPRESS</h2>
        <a class="text-center text-danger text-decoration-none small"
          href="https://asesorcontable.mx/" target="_blank">www.asesorcontable.mx
        </a>
        <div class="d-flex justify-content-center align-items-center gap-2">
          <mat-icon class="text-danger">support_agent</mat-icon>
          <a class="text-danger text-decoration-none" href="tel:3331231565">33-3123-1565</a>
        </div>
      </div>

      <div class="col-3 text-center">
        <img src="assets/images/logo.png" style="max-height: 60px;" class="img-fluid" *ngIf="accesoExpress.imagenUrl"/>
      </div>
    </div>
  </div>

  <!-- ============================================ parte azul ============================================== -->
  <div class="container-fluid border-top border-secondary shadow-sm bg-primary">
    <div class="row align-items-center text-center">
      <div class="col-3 d-flex justify-content-center gap-3 flex-wrap">
        <ng-container *ngIf="!accesoExpress.isActive">
          <span class="text-danger d-flex align-items-center gap-1">
            <mat-icon>warning</mat-icon> Acceso desactivado
          </span>
        </ng-container>

        <!-- ============================================ botón volumen ============================================= -->
        <div *ngIf="this.accesoExpress.habilitarSonido" class="text-white cursor-pointer" (click)="cambiarSonido()">
          <mat-icon>{{ iconoVolumen }}</mat-icon>
        </div>

        <!-- ============================================ botón cámara ============================================== -->
        <div *ngIf="this.accesoExpress.faceDetectionEnabled" class="text-white cursor-pointer" (click)="mostrarFaceIdClick()">
          <mat-icon>{{ iconoCamara }}</mat-icon>
        </div>

        <!-- ============================================ botón pantalla completa ============================================== -->
        <mat-icon *ngIf="!esPantallaCompleta" class="text-white cursor-pointer" (click)="pantallaCompleta()">fullscreen</mat-icon>
        <mat-icon *ngIf="esPantallaCompleta" class="text-white cursor-pointer" (click)="salirPantallaCompleta()">fullscreen_exit</mat-icon>

        <!-- ============================================ botón configuración en wifi ============================================== -->
        <ng-container [ngSwitch]="connectionState.state">
          <mat-icon *ngSwitchCase="'connected'" class="text-white" title="Conectado" (click)="abrirConfig()">wifi</mat-icon>
          <mat-icon *ngSwitchCase="'connecting'" class="text-warning">motion_photos_on</mat-icon>
          <mat-icon *ngSwitchDefault class="text-danger" title="Desconectado" (click)="abrirConfig()">wifi_off</mat-icon>
        </ng-container>

        <mat-icon *ngIf="estaHibernando" class="text-white cursor-pointer" (click)="quitarHibernacion()">bedtime_off</mat-icon>
      </div>

      <!-- ============================================ nombre del punto de acceso ============================================== -->
      <div class="col-6 text-center text-white">
        <button class="text-white border-0 bg-primary" (click)="idEmpleadoActivo = undefined; modoAdmin = 1;">
          <h3 class="mb-0">{{ accesoExpress.companyName }} <span *ngIf="modoFullDebug" class="small">| ({{ accesoExpress.companyId }}) </span></h3>
        </button>
        <p class="mb-0">Acceso: {{ accesoExpress.accesoNombre }}
          <span *ngIf="modoAdmin > 0" class="fw-semibold">| Admin: Activado</span>
        </p>
      </div>

      <!-- ============================================ reloj ============================================== -->
      <div class="col-3 text-center">
        <h2 class="text-white fw-light cursor-pointer mb-0" (click)="idEmpleadoActivo = undefined; modoAdmin = 2;">
          {{ horaPuntoDeAcceso }}
        </h2>
      </div>
    </div>
  </div>
</div>

<div class="mb-5" *ngIf="estaCargando">
  <div class="text-center p-5">
    <img src="../assets/images/ACE_Acceso-Express.png" class="pt-3 img-fluid" width="150" height="150"/>
  </div>
  <div class="text-center">
    <mat-spinner class="img-center"></mat-spinner>
  </div>
  <div class="text-center py-5">
    <span>Cargando datos...</span>
  </div>
   <div class="fixed-bottom pe-3 small text-muted gap-2 d-flex justify-content-end align-items-end">
    <div class="text-body-tertiary" (click)="abrirLog()">Log |</div>
    <div>v {{versionAccesoExpress}}{{servicioReconocimiento}} |</div>
    <div *ngIf="mensajeAddInicioApp"> - {{mensajeAddInicioApp}}</div>
  </div>
</div>

<div class="d-flex justify-content-center renovacion mt-2" *ngIf="renovar && !estaCargando" (click)="quitarRenovacion()">
  <span class="text-danger fs-5 fw-semibold">{{ renovar }}</span>
</div>

<div class="mt-1 container-fluid" id="qr-access" [ngClass]="{ small: true }" *ngIf="!estaCargando">
  <div class="row justify-content-center align-items-start mx-auto">
    <!-- ============================================ cámara ============================================== -->
    <div class="col-12 col-md-6 px-3 py-3">
      <div *ngIf="mostrarFaceID">
        <div class="cam-wrapper position-relative" (window:resize)="onResize($event)">
          <div id="codigoQrDiv" class="position-relative">
            <webcam
              [width]="camaraAncho"
              [height]="camaraAlto"
              [allowCameraSwitch]="true"
              [videoOptions]="videoOptions"
              [trigger]="invokeObservable"
              (imageCapture)="captureImg($event)"
              [switchCamera]="nextWebcamObservable"
              [ngClass]="{'opacity-75': estaHibernando}">
            </webcam>
            <!-- [mirrorImage]="'always'"  -->
            <!-- <canvas id="face-marks" style="position: absolute; z-index: 1"></canvas> -->
            <canvas id="face-marks" class="position-absolute top-0 start-0 z-1"></canvas>
            <div class="position-absolute start-50 translate-middle z-2 px-3 w-100" style="top: 80%;">
              <div *ngIf="mensaje" class="centro bg-primary text-white rounded p-2 mb-1 shadow-sm">
                <span class="fs-6">{{mensaje}}</span>
              </div>
              <div *ngIf="estaHibernando" class="centro bg-secondary-subtle text-dark rounded p-2 mb-1 shadow-sm" (click)="quitarHibernacion()">
                <span class="fs-6">El sistema está hibernando</span>
              </div>
              <div *ngIf="error" class="centro bg-danger text-white rounded p-2 shadow-sm">
                <span class="fs-6">{{error}}</span>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="infoCamara && this.accesoExpress.infoReconocimientoFacial" class="text-muted">
          <span>{{infoCamara}}</span>
        </div>
      </div>

      <!-- ============================================ sin cámara ============================================== -->
      <div class="d-none d-md-block" *ngIf="!mostrarFaceID">
        <!-- <img src="{{accesoExpress.imagenUrl}}" alt="" height="300px" *ngIf="accesoExpress.imagenUrl"> -->
        <img [src]="accesoExpress.imagenUrl || '../../../../assets/images/logo.png'" alt="Imagen" height="300">
        <div class="centro bg-primary text-white rounded p-2 mt-2 shadow-sm" *ngIf="mensaje">
          <span class="fs-6">{{mensaje}}</span>
        </div>
        <div class="centro bg-danger text-white rounded p-2 mt-2 shadow-sm" *ngIf="error">
          <span class="fs-6">{{error}}</span>
        </div>
      </div>
    </div>

    <!-- ============================================ codigo Qr ============================================== -->
    <div class="col-12 col-md-6 py-3" *ngIf=" accesoExpress.isActive">
      <div class="bg-white rounded shadow-sm p-4" *ngIf="!codigoQR || codigoQR === '-'">
        <mat-spinner class="d-block mx-auto mb-3"></mat-spinner>
        <p class="text-muted">{{proceso}}</p>
        <div *ngIf="accesoExpress.debug">
          <code>{{codigoQR}}</code>
        </div>
      </div>

      <div class="bg-white rounded shadow-sm" *ngIf="codigoQR && codigoQR !== '-'">
        <qrcode
          [qrdata]="codigoQR"
          [errorCorrectionLevel]="'M'"
          [colorDark]="'#01579bff'"
          [colorLight]="'#fafafa00'"
          [width]="qrAncho">
        </qrcode>

        <div *ngIf="!estaEscuchando" class="bg-danger text-white rounded mt-3 p-2 fs-6 shadow-sm">
          <b *ngIf="!buscandoConexion">Sin conexión con el servidor</b>
          <b *ngIf="buscandoConexion">Validando datos del servidor</b>
        </div>
      </div>

      <div class="text-center mt-3" *ngIf="mostrarFaceID">
        <img [src]="accesoExpress.imagenUrl || '../../../../assets/images/logo.png'" width="180" class="object-fit-contain" alt="Logo">
      </div>

      <!-- ============================================ botones ============================================== -->
      <div class="d-none d-xl-flex justify-content-center flex-wrap gap-2 mt-3" *ngIf="!estaCargando && accesoExpress.isActive">
        <button mat-raised-button class="bg-secondary-subtle text-primary shadow-sm" (click)="cambiarSonido()" *ngIf="accesoExpress.habilitarSonido">
          <mat-icon>{{ iconoVolumen }}</mat-icon>
        </button>
        <button mat-raised-button class="bg-secondary-subtle text-primary shadow-sm" (click)="mostrarFaceIdClick()" *ngIf="accesoExpress.faceDetectionEnabled">
          <mat-icon>{{ iconoCamara }}</mat-icon>
        </button>
        <button mat-raised-button class="bg-secondary-subtle text-primary shadow-sm" (click)="pantallaCompleta()" *ngIf="!esPantallaCompleta">
          <mat-icon>fullscreen</mat-icon>
        </button>
        <button mat-raised-button class="bg-secondary-subtle text-primary shadow-sm" (click)="salirPantallaCompleta()" *ngIf="esPantallaCompleta">
          <mat-icon>fullscreen_exit</mat-icon>
        </button>
        <button mat-raised-button class="bg-secondary-subtle text-primary shadow-sm" (click)="abrirConfig()" *ngIf="!esPantallaCompleta">
          <mat-icon>settings</mat-icon>
        </button>
        <button mat-raised-button class="bg-secondary-subtle text-primary shadow-sm" (click)="quitarHibernacion()" *ngIf="estaHibernando">
          <mat-icon>bedtime_off</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <!-- ============================================ datos de version y otras cosas ============================================== -->
  <div class="fixed-bottom pe-3 small text-muted gap-2 d-flex justify-content-end align-items-end">
    <!-- <div *ngIf="accesoExpress.mostrarInfoAdd && infoAdd">
      <span class="pe-2">{{infoAdd}}</span>
      <br/>
    </div> -->
    <div>v {{versionAccesoExpress}}{{servicioReconocimiento}} |</div>
    <div class="text-body-tertiary"><mat-icon style="font-size: 15px; position: relative; top: 12px; width: 12px;">sync</mat-icon> {{fFecha(inicioApp)}}</div>
    <div *ngIf="mensajeAddInicioApp"> - {{mensajeAddInicioApp}}</div>
  </div>
</div>

